import type {
  CmmdTaskStatus,
  CmmdWorkItemType,
  CreateCmmdBoardTaskParams,
} from "@cmmd-forge/contracts";
import type { ProjectTaskCreatePriority } from "./projectTaskCreateOptions";

export interface CreateTaskDraft {
  readonly title: string;
  readonly description: string;
  readonly status: CmmdTaskStatus;
  readonly priority: ProjectTaskCreatePriority | null;
  readonly workItemType: CmmdWorkItemType;
  readonly assignee: number | null;
  readonly dueDate: string;
  readonly parentTaskId: number | null;
  readonly milestoneId: number | null;
  readonly workflowStageId: string | null;
  readonly dependencyIds: readonly number[];
}

export function buildCreateTaskParams(draft: CreateTaskDraft): CreateCmmdBoardTaskParams {
  return {
    title: draft.title,
    ...(draft.description.trim().length > 0 ? { description: draft.description } : {}),
    status: draft.status,
    ...(draft.priority !== null ? { priority: draft.priority } : {}),
    workItemType: draft.workItemType,
    assignee: draft.assignee,
    dueDate: draft.dueDate.length > 0 ? draft.dueDate : null,
    parentTaskId: draft.parentTaskId,
    milestoneId: draft.milestoneId,
    ...(draft.workflowStageId != null ? { workflowStageId: draft.workflowStageId } : {}),
    dependsOn: [...draft.dependencyIds],
  };
}
